// v2/utils/mapCartItem.js — /api/v2/cart/ kalemini useCart satir yapisina cevirir
//
// API kalemi:  {Id, SipKod, UrunKodu, UrunAdi, BrutFiyat, NetFiyat, IndOran,
//               GAUrunAdedi, ANUrunAdedi, Durum, discounts, gzt_stock, ist_stock}
// Satir       : {key, sipKod, product, qty:{gaziantepStock, istanbulStock}, status}
//
// NOT: GAUrunAdedi -> Gaziantep, ANUrunAdedi -> ISTANBUL deposu
// (backend'de kolon adi tarihsel nedenle "AN" ama veri Istanbul'a ait).

import { urunGorseli, urunGorselleri } from './mapProduct';
import { withVat } from './discount';

const GZT = 'gaziantepStock';
const IST = 'istanbulStock';

function sayi(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

/** 'Beklemede' duzenlenebilir; 'Islemde' siparis verilmis, 'Transfer Edildi' ERP'ye gitmis.
 *  pending disindaki her durum kilitlidir. */
export function durumdanStatus(durum) {
  if (durum === 'Beklemede') return 'pending';
  if (durum === 'İşlemde') return 'processing';
  return 'transferred';
}

export function mapCartItem(k) {
  const kod = (k.UrunKodu || '').trim();
  const brut = sayi(k.BrutFiyat);
  const net = sayi(k.NetFiyat);

  const zincir = Array.isArray(k.discounts) ? k.discounts : [];

  return {
    key: String(k.Id),
    id: k.Id,
    sipKod: k.SipKod,
    status: durumdanStatus(k.Durum),
    durum: k.Durum,
    aciklama: k.Aciklama || '',
    eklemeTarihi: k.EklemeTarihi || null,

    // fiyat degisti bilgisi — sepet acilinca kullaniciya bildirilecek
    fiyatDegisti: Boolean(k.fiyat_degisti),
    eskiNet: k.eski_net === null || k.eski_net === undefined ? null : sayi(k.eski_net),
    urunBulundu: k.urun_bulundu !== false,

    product: {
      id: kod,
      productCode: kod,
      description: k.UrunAdi || '',
      groupCode: k.GrupKodu || '',
      brand: 'BOSCH',
      image: urunGorseli(kod, 1),
      images: urunGorselleri(kod),

      grossPrice: brut,
      netPrice: net,
      vatPrice: withVat(net),
      savingAmount: Math.max(brut - net, 0),
      discountRate: sayi(k.IndOran),
      discounts: zincir,
      campaign: zincir.length ? { rate: zincir[0].rate } : null,
      grossPriceEur: sayi(k.euro_brut_price),

      // depo stoklari — bilesenler p[wh.key] ile okuyor
      [GZT]: sayi(k.gzt_stock),
      [IST]: sayi(k.ist_stock),
      gaziantepStock: sayi(k.gzt_stock),
      istanbulStock: sayi(k.ist_stock),
    },

    qty: {
      [GZT]: sayi(k.GAUrunAdedi),
      [IST]: sayi(k.ANUrunAdedi),
    },
  };
}

export function mapCartItems(list) {
  return (Array.isArray(list) ? list : []).map(mapCartItem);
}

/** Satirdan API govdesine — miktar guncellemede kullanilir */
export function satirdanMiktar(line) {
  return {
    gaUrunAdedi: sayi(line.qty[GZT]),
    anUrunAdedi: sayi(line.qty[IST]),
  };
}

export const DEPO_ANAHTARLARI = { GZT, IST };

export default mapCartItems;
